<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title">
          <img src="../assets/logo.png" alt="" />
        </h3>
      </div>
      <el-form-item class="codebox" prop="usernames">
        <!-- <span class="svg-container">
          <svg-icon icon-class="user" />
        </span> -->
        <!-- <i class="el-icon-s-custom"></i> -->
        <span class="login_left">用户名</span>
        <el-input
          ref="usernames"
          v-model="loginForm.username"
          placeholder="请输入用户名"
          name="usernames"
          type="text"
          tabindex="1"
          autofocus
        />
      </el-form-item>

        <el-form-item class="codebox">
          <!-- <span class="svg-container">
            <svg-icon icon-class="password" />
          </span> -->
          <!-- <i class="el-icon-s-opportunity"></i> -->
          <span class="login_left">密码</span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="passwords"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            @keyup.native="checkCapslock"
          />
          <span class="show-pwd" @click="showPwd">
            <!-- <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" /> -->
            <!-- <i :class="showpassword"></i> -->
            <img class="icons" :src="showpassword" alt="" />
          </span>
        </el-form-item>
      <el-form-item class="codebox" prop="usercode">
        <!-- <span class="svg-container">
          <svg-icon icon-class="user" />
        </span> -->
        <!-- <i class="el-icon-message-solid"></i> -->
        <span class="login_left">验证码</span>
        <el-input
          ref="usercode"
          v-model="loginForm.code"
          placeholder="请输入验证码"
          name="usercode"
          type="text"
          tabindex="3"
          @keyup.enter.native="handleLogin"
          class="code_class"
        />
        <el-image
          style="width: 160px; height: 40px"
          :src="url"
          fit="contain"
          @click="getCaptcha()"
        ></el-image>
      </el-form-item>
      <div style="width: 100%; display: flex; justify-content: center">
        <el-button
          :loading="loading"
          type="primary"
          tabindex="4"
          class="logins"
          @click.native.prevent="handleLogin"
        >
          <!-- {{ $t('login.logIn') }} -->
          医生登录
        </el-button>
      </div>
      <div style="position: relative" />
    </el-form>
    <div class='Version'>
      Copyright©2022-2025 All rights reserved. 版本号：1
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
// // import LangSelect from '@/components/LangSelect'
// import { getAllApi } from '@/api/system'
// import SocialSign from './components/SocialSignin'
// import { login } from '@/api/user.js'
export default {
  name: "Login",
  //   components: { SocialSign },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    return {
      url: "",
      passwords:'',
      showpassword: require("../assets/闭眼.png"),
      pathUrl: "",
      loginForm: {
        username: "",
        password: "",
        code: "",
        id: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
        code: [{ required: true, trigger: "blur", validator: validateCaptcha }],
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      isCurrent: true,
      otherQuery: {},
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getCaptcha();
    console.log(window.location.href.split('?loadType=')[1])
    if(window.location.href.split('?loadType=')[1] == '1'){
       sessionStorage.setItem("loadType", window.location.href.split('?loadType=')[1]);
    }else {
      sessionStorage.setItem("loadType", 2);
    }
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    //11
    this.$nextTick(() => {
      this.isCurrent = false;
    });
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      depot
        .get({
          url: "/backend/sign/getCaptcha",
          config: {},
          // cb: (res) => {
          // },
        })
        .then((res) => {
          console.log(res);
          this.loginForm.id = res.data.id;
          this.url = res.data.data;
        });
    },
    // 监听密码键盘事件
    checkCapslock({ shiftKey, key } = {}) {
      console.log(shiftKey);
      console.log(key);
      console.log(this.capsTooltip);
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= "a" && key <= "z") ||
          (!shiftKey && key >= "A" && key <= "Z")
        ) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    // 点击显示密码
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
        console.log(1);
        this.showpassword = require("../assets/眼睛.png");
      } else {
        console.log(2);
        this.passwordType = "password";
        this.showpassword = require("../assets/闭眼.png");
      }
      // this.$nextTick(() => {
      //   this.$refs.password.focus();
      // });
    },
    // 请求登录接口
    handleLogin() {
      if(this.loginForm.username == ''){
        this.$message({
                  message: "请输入用户名",
                  type: "error",
                });
                return
      }else if(this.loginForm.passwords == ''){
         this.$message({
                  message: "请输入密码",
                  type: "error",
                });
                return
      }
      const Base64 = require('js-base64').Base64
      this.loginForm.password = Base64.encode(this.passwords)
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          depot
            .post({
              url: "/backend/sign/login",
              data: this.loginForm,
              //   cb: (res) => {
              //     if (res.success == true) {

              //     }
              //     // this.$router.push({ path: 'dashboard' })
              //     console.log(res);
              //   },
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.loading = false;
                sessionStorage.setItem("token", res.data);
                localStorage.setItem("token", res.data);
                console.log(sessionStorage.getItem("token"));
                this.$message({
                  message: "登录成功",
                  type: "success",
                });
                 this.$http
        .post(
          "http://localhost:9091/v1/user/setToken?token=" +
            sessionStorage.getItem("token")
        )
        .then((response) => {
          console.log(response);
        })
        .catch((err) => {
          console.error(err);
        });
                depot
                  .get({
                    url: "/backend/info/queryMyInfo",
                    params: {
                      token: sessionStorage.getItem("token"),
                    },
                    config: {},
                  })
                  .then((res) => {
                    console.log(res.success);
                    // console.error(res.data.backendMenus[0].url);
                   if(res.success == false){
                      console.log(123)
                     this.$router.push({ path: '/sys/changepassword' });
                   }else {
                      if (res.data.backendMenus[0].url == "") {
                      this.pathUrl = res.data.backendMenus[1].url;
                      console.log(this.pathUrl);
                    } else {
                      this.pathUrl = res.data.backendMenus[0].url;
                      console.log(this.pathUrl);
                    }
                    this.$router.push({ path: this.pathUrl });
                   }
                   
                  });
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
              this.getCaptcha();
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // getAllApis() {
    //   // 获取所有API
    //   getAllApi({}).then(res => {
    //     const apiObj = {}
    //     res.data.forEach((v, i) => {
    //       if ([v.primary_key]) {
    //         apiObj[v.primary_key] = { path: v.path, method: v.method }
    //       }
    //     })
    //     // 存 session防止刷新丢失
    //     sessionStorage.setItem('apiList', JSON.stringify(apiObj))
    //     this.$router.push({ path: 'dashboard' })
    //     // 存  vuex
    //     this.$store.state.app.apiList = apiObj
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // }
  },
  beforeRouteLeave(to,from,next){
   to.meta.keepAlive = false
   next(0)
 },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
    background: rgb(255, 250, 250) !important;
    border-radius: 4px !important;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;
      color: #303030;
      caret-color: #303030;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #303030 !important;
      }
    }
  }

  .el-form-item {
    // border-bottom: 1px solid #aaaaaa;
    // background: rgba(0, 0, 0, 0.3);
    // border-radius: 5px;
    color: #303030;
    // background: #fff;
  }
}
.Version {
  position: fixed;
    max-width: 100%;
    width: 100%;
    top: 92%;
    // margin-top: -334px;
    // left: 50%;
    // margin-left: -330px;
    color: #fff;
    overflow: hidden;
    display: flex;
    align-items: center;
    border-radius: 12px;
    justify-content: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 999;
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
.text {
  .current {
    transform: translate(-150px);
    opacity: 0;
  }

  min-height: 100%;
  width: 100%;
  background: rgba(49, 51, 64, 1);
  opacity: 0.84;
  position: absolute;
  top: 0;
  left: 0;
  .text_content {
    width: 564px;
    position: absolute;
    top: 380px;
    left: 220px;
    height: 323px;
    text-align: center;
    user-select: none;
    .name {
      width: 100%;
      height: 67px;
      font-size: 48px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 67px;
    }
    .title {
      width: 100%;
      height: 33px;
      font-size: 24px;
      color: rgba(255, 255, 255, 1);
      line-height: 33px;
      letter-spacing: 12px;
    }
    .line {
      width: 160px;
      height: 1px;
      background: rgba(255, 255, 255, 1);
      margin: 25px auto;
    }
    .txt {
      width: 100%;
      font-size: 28px;
      color: rgba(255, 255, 255, 1);
      line-height: 56px;
      transition: transform 1s;
    }
  }
}
.login-container {
  position: relative;
  min-height: 100%;
  width: 100%;
  // background-color: $bg;
  background: url("../assets/backimg.png") no-repeat center center;
  background-size: 100% 100%;
  overflow: hidden;
  .login-form {
    position: fixed;
    max-width: 100%;
    // padding: 35px;
    padding: 69px 128px 94px;
    // margin: 125px auto;
    top: 50%;
    margin-top: -334px;
    left: 50%;
    margin-left: -330px;
    overflow: hidden;
    width: 660px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    box-sizing: border-box;
    z-index: 999;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    // color: $dark_gray;
    color: #5997fd;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    margin-bottom: 90px;
    .title {
      font-size: 42px;
      color: #5997fd;
      // color:#eee;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: 500;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
/deep/.codebox .el-form-item__content {
  display: flex !important;
  align-items: center;
}
.login_left {
  display: inline-block;
  margin-right: 20px;
  width: 75px;
  text-align: right;
}
/deep/.el-form-item__content {
  display: flex;
}
.code_class {
  width: 185px !important;
  margin-right: 15px;
}
.icons {
  width: 20px;
  height: 20px;
}
.logins {
  width: 302px;
  height: 51px;
  border-radius: 25.5px;
  background: rgba(238, 238, 238, 0.22);
  color: #009b43;
  border: 1px solid #009b43;
  margin-top: 81px;
  transition: all ease 0.5s;
}
.logins:hover {
  background: #009b43 !important;
  transition: all ease 0.5s;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue